// extracted by mini-css-extract-plugin
module.exports = {"categories":"CategoriesContainer_categories__1ZLaa","category":"CategoriesContainer_category__8vm68"};